"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var Icon_1 = __importStar(require("../Icon"));
var progressIndicator = function (props) {
    var cn = classnames_1.default("respectkit__progress_indicator", {
        small: props.small,
    });
    var indicator = (react_1.default.createElement("div", { className: cn },
        react_1.default.createElement(Icon_1.default, { icon: Icon_1.IconType.Spinner, width: 56, height: 56 })));
    var containerCn = classnames_1.default(props.className, "progress_indicator_overlay", {
        respectkit__overlay: props.small !== true /* eslint-disable-line @typescript-eslint/naming-convention */,
        dark_bg: props.overlay === "dark" || props.overlay === undefined,
        clean_bg: props.overlay === "clean",
        white_bg: props.overlay === "white",
        light_bg: props.overlay === "light",
        local: props.local === true,
    });
    return react_1.default.createElement("div", { className: containerCn }, indicator);
};
exports.default = progressIndicator;
//# sourceMappingURL=index.js.map